import http from '@/utils/services/http'

export default {
  list (limit, page, filtros) {
    return http.get('/api/policiacivil/processo/peritovistoriador/?page=' + page + '&limit=' + limit + filtros)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastrar (data, id = null) {
    if (id) {
      return this.update(data, id)
    }
    return http.post('/api/policiacivil/processo/peritovistoriador/new', JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/policiacivil/processo/peritovistoriador/' + id)
      .then(response => {
        console.log(response)
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  update (data, id) {
    return http.patch('/api/policiacivil/processo/peritovistoriador/' + id + '/update', JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  delete (id) {
    return http.delete('/api/policiacivil/processo/peritovistoriador/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/policia-civil/perito-vistoriador/services/perito-vistoriador.js